const showSubMenus = () => {
  const featuredMenu = document.getElementById('featured-sub-menu');
  const newestMenu = document.getElementById('newest-sub-menu');
  const saleMenu = document.getElementById('sale-sub-menu');
  const saleIcon = document.getElementById('sub-icon-sale');
  const newestIcon = document.getElementById('sub-icon-newest');
  const featuredIcon = document.getElementById('sub-icon-featured');
  
  featuredMenu.classList.remove('hide-sub-menu-mobile');
  featuredMenu.classList.add('featured-sub-container-mobile');
  newestMenu.classList.remove('hide-sub-menu-mobile');
  newestMenu.classList.add('newest-sub-container-mobile');
  saleMenu.classList.remove('hide-sub-menu-mobile');
  saleMenu.classList.add('sale-sub-container-mobile');

  setTimeout(() => {
    saleIcon.classList.remove('link-sub-icon-mobile-hidden');
    saleIcon.classList.add('link-sub-icon-mobile-visible');
  }, 200);
  setTimeout(() => {
    newestIcon.classList.remove('link-sub-icon-mobile-hidden');
    newestIcon.classList.add('link-sub-icon-mobile-visible');
  }, 400);    
  setTimeout(() => {
    featuredIcon.classList.remove('link-sub-icon-mobile-hidden');
    featuredIcon.classList.add('link-sub-icon-mobile-visible');
  }, 600);
};

const hideSubMenus = () => {
  console.log("HIDING SUB MENUS");
  const featuredMenu = document.getElementById('featured-sub-menu');
  const newestMenu = document.getElementById('newest-sub-menu');
  const saleMenu = document.getElementById('sale-sub-menu');
  const saleIcon = document.getElementById('sub-icon-sale');
  const newestIcon = document.getElementById('sub-icon-newest');
  const featuredIcon = document.getElementById('sub-icon-featured');    
  
  setTimeout(() => {
    featuredMenu.classList.remove('featured-sub-container-mobile');
    newestMenu.classList.remove('newest-sub-container-mobile');
    saleMenu.classList.remove('sale-sub-container-mobile');
  }, 200);

  setTimeout(() => {
    featuredMenu.classList.add('hide-sub-menu-mobile');
    newestMenu.classList.add('hide-sub-menu-mobile');
    saleMenu.classList.add('hide-sub-menu-mobile');
  }, 900);

  featuredIcon.classList.remove('link-sub-icon-mobile-visible');
  featuredIcon.classList.add('link-sub-icon-mobile-hidden');

  setTimeout(() => {
    newestIcon.classList.remove('link-sub-icon-mobile-visible');
    newestIcon.classList.add('link-sub-icon-mobile-hidden');
  }, 200);    
  setTimeout(() => {
    saleIcon.classList.remove('link-sub-icon-mobile-visible');
    saleIcon.classList.add('link-sub-icon-mobile-hidden');
  }, 400);
};

const isMobileNavSubMenuOpen = () => {
  const flap = document.getElementById('link-sub-open-rect-group');
  return flap.classList.contains('link-sub-is-open');
};

const openFlap = () => {
  const flap = document.getElementById('link-sub-open-rect-group');
  const shopLinkContainer = document.getElementById('shop-link-mobile');
  const subCategoryIcon = document.getElementById('subcategory_icon_mobile');

  flap.classList.add('link-sub-is-open');
  shopLinkContainer.classList.add('shop-sub-menu-mobile-open');
  setTimeout(() => {
    subCategoryIcon.classList.add('hide-subcategory-icon-mobile');
  }, 200);
}

const closeFlap = () => {
  const flap = document.getElementById('link-sub-open-rect-group');
  const shopLinkContainer = document.getElementById('shop-link-mobile');
  const subCategoryIcon = document.getElementById('subcategory_icon_mobile');

  flap.classList.remove('link-sub-is-open');
  shopLinkContainer.classList.remove('shop-sub-menu-mobile-open');
  setTimeout(() => {
    subCategoryIcon.classList.remove('hide-subcategory-icon-mobile');
  }, 200);
}

const toggleSubFlap = () => {
  if (isMobileNavSubMenuOpen()) { 
    setTimeout(() => {
      closeFlap();
    }, 200);
    hideSubMenus();
  } else {
    openFlap();
    showSubMenus();
  }
};

const hideScrollButtonByClass = () => {
  const scrollToTopBtn = document.getElementById('my-scroll-to-top');

  scrollToTopBtn.classList.remove('show-scroll-to-top-button');
  scrollToTopBtn.classList.add('hide-scroll-to-top-button');
};

const showScrollButtonByClass = () => {
  const scrollToTopBtn = document.getElementById('my-scroll-to-top');

  scrollToTopBtn.classList.remove('hide-scroll-to-top-button');
  scrollToTopBtn.classList.add('show-scroll-to-top-button');
};

const activateScrllToTopButton = () => {
  const scrollToTopIcon = document.getElementById('scroll-to-top-icon');

  scrollToTopIcon.classList.add('scroll-to-top-icon-active');
  scrollToTopIcon.classList.remove('scroll-to-top-icon-inactive');
};

const deactivateScrllToTopButton = () => {
  const scrollToTopIcon = document.getElementById('scroll-to-top-icon');

  scrollToTopIcon.classList.add('scroll-to-top-icon-inactive');
  scrollToTopIcon.classList.remove('scroll-to-top-icon-active');
};

export const initScrollToTopButton = () => {
  const scrollToTopBtn = document.getElementById('my-scroll-to-top');

  function toggleScrollButton() {
    let ticking = false;

    if (!ticking) {
      window.requestAnimationFrame(function() {
        if (window.scrollY === 0) {
          deactivateScrllToTopButton();
        }
        ticking = false;
      });
      ticking = true;
    }

    if (window.scrollY > 200) {
        if (!isMobileNavOpen()) { 
          showScrollButtonByClass();
        }
    } else {
        hideScrollButtonByClass();
    }
  }

  if (scrollToTopBtn) {
    window.addEventListener('scroll', toggleScrollButton);
  }

  scrollToTopBtn.addEventListener('click', function() {
    activateScrllToTopButton();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};

export const initMobileNavToggleButton = () => {
    const button = document.getElementById('nav-toggle-button-mobile');

    if (button) {
      button.addEventListener('click', () => {
        toggleMobileNav();
      });
    }
  };

  export const initMobileNavSubMenuToggleButton = () => {
    const navMenuButton = document.getElementById('link-sub-open-rect-group');
    
    if (navMenuButton) {
      navMenuButton.addEventListener('click', toggleSubFlap);
    }
  };

  export const isMobileNavOpen = () => {
    const mobileNav = document.querySelector('.nav-menu-container-mobile');
    return mobileNav.classList.contains('show-nav-menu-mobile');
  };
  
  export const toggleMobileNav = () => {
    const navMenu = document.querySelector('.nav-menu-container-mobile');
          const navContainerMobile = document.querySelector('.nav-container-mobile');
  
          if (isMobileNavOpen()) {
            closeFlap();
            hideSubMenus();
            if (window.scrollY > 200) {
              showScrollButtonByClass();
            }
          } 
          else {
            hideScrollButtonByClass();
          }
  
          navMenu.classList.toggle('show-nav-menu-mobile');
          navContainerMobile.classList.toggle('raise-nav-container-mobile-index');
  };